import React from 'react';
import accounting from 'accounting';
const kennitala = require('kennitala')
import { formatKennitala, Spinner, formatMoney, getUrlParam } from '../../utils'
import { gettext } from '../../locale'
import moment from 'moment'
import { Bar } from 'react-chartjs-2';
import OfferTable from '../offer-table'

import ContractLine from '../contract-line'
import 'chartjs-plugin-colorschemes';


class OfferVidt extends React.Component {

    constructor(props) {
        super(props)
    }

    render() {
        let customer = this.props.customer
        let portfolioType = this.props.infoCollection.VIDTPortfolio
        // let offer = this.props.offers.offers[this.props.customerId][this.props.offerType]

        // let offer = this.props.offers.offers[customer.Customer.AccountNum][this.props.offerType]
        let offer = this.props.offer[this.props.offerType]

        let parameters = offer.parameters
        let keyFigures = offer.keyFigures

        let options = {
            scales: {
                xAxes: [{
                    type: 'time',
                    time: {
                        unit: 'year'
                    }
                }]
            },
            plugins: {
                colorschemes: {
                    scheme: 'tableau.HueCircle19'
                }
            }
        }


        let lifetimeColumns = ["monthlyPayment"]

        if(portfolioType == 'perspektive'){
            lifetimeColumns.push("Ges. Einmalzahlung bei Tod am Anfang des Vers.-Jahres", "Gesamtleistung bei Rückkauf")
        } else {
            let kdPercentage = accounting.formatMoney(+keyFigures["HochrechnungsProzentsatz5"], '', 1, "", ".");
            kdPercentage = kdPercentage.replace(".0", "")
            lifetimeColumns.push(`Fondswert (Todesfallleistung) mit ${kdPercentage}% Fondswertsteigerung`, `Gesamtleistung bei Rückkauf bei ${kdPercentage}% Wertsteigerung`)
        }
        // let lifetimeColumns = [
        //     "monthlyPayment",
        //     "Ges. Einmalzahlung bei Tod am Anfang des Vers.-Jahres",
        //     "Gesamtleistung bei Rückkauf",
        // ]
        let lifetimeDatasets = []
        let lifetimeChartKeys = lifetimeColumns
        //let chartKeys = ["Gesamtleistung bei Rückkauf", "Laufende Gesamtrente der HV gemäß Rentenzw", "Ges.Leistung bei Tod in der Rentenlaufzeit", "monthlyPayment"]

        let postColumns = [
            "Laufende Gesamtrente der HV gemäß Rentenzw",
            "Ges.Leistung bei Tod in der Rentenlaufzeit",
        ]
        let postDatasets = []
        let postChartKeys = postColumns


        let isOneTimePayment = this.props.infoCollection.VIDTonetime

        if (offer.isFetching || this.props.customer.isFetching) {
            return <Spinner />
        } else {

            if (offer.error) {
                return (<>
                    { offer.errorMessage }
                </>)
            }

            try {

                Object.keys(offer.timeSeries[customer.Customer.AccountNum]["VIDT"]).map(i => {
                    if (lifetimeChartKeys.includes(i)) {
                        lifetimeDatasets.push({
                            data: offer.timeSeries[customer.Customer.AccountNum]["VIDT"][i],
                            label: `${gettext(i)} (${gettext(i, "de")})`
                        })
                    }
                })


            } catch (e) {
                console.log(e)
            }

            let lifetimeData = {
                datasets: lifetimeDatasets,
            }



            try {

                Object.keys(offer.timeSeries[customer.Customer.AccountNum]["VIDT"]).map(i => {
                    if (postChartKeys.includes(i)) {
                        postDatasets.push({
                            data: offer.timeSeries[customer.Customer.AccountNum]["VIDT"][i],
                            label: `${gettext(i)} (${gettext(i, "de")})`
                        })
                    }
                })


            } catch (e) {
                console.log(e)
            }

            let postData = {
                datasets: postDatasets,
            }

            let kapitalBeiUnfalltod = (parseFloat(keyFigures["Garantiekapital"]) * parseFloat(keyFigures.Wert["UZ"])) / 100

            let contractMonths = ""
            if (this.props.infoCollection.VIDTtype == "insuranceamount") {
                contractMonths = parameters.length*12
            }

            return (<>
                <div className="row justify-content-center xs-pt-50 offer">
                    <div className="col-12">
                        <h3>Persónuupplýsingar</h3>
                        {customer.Customer.Name}<br />

                        Dagsetning tilboðs {moment.utc().format("D.M.YYYY")}

                    </div>
                </div>

                <div className="row justify-content-center xs-pt-50 offer">
                    <div className="col-12">
                        <h3>Forsendur útreikninga</h3>
                        <table className="table table-hover table-sm table-offer table-responsive-sm">
                            <tbody>
                                <tr>
                                    <td>
                                        <strong>{gettext("startDate")}</strong> ({gettext("startDate", "de")})
                                    </td>
                                    <td className="text-right nowrap">
                                        {parameters.start.format("D.M.YYYY")}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <strong>{gettext("endDate")}</strong> ({gettext("endDate", "de")})
                                    </td>
                                    <td className="text-right nowrap">
                                        {parameters.end.format("D.M.YYYY")}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <strong>{gettext("contractLength")}</strong> ({gettext("contractLength", "de")})
                                    </td>
                                    <td className="text-right nowrap">
                                        {parameters.length} ár
                                    </td>
                                </tr>
                                { portfolioType == 'komfortdynamik' &&            
                                    <tr>
                                        <td>
                                            <strong>{gettext("kdGarantieProzent")}</strong> ({gettext("kdGarantieProzent", "de")})
                                        </td>
                                        <td className="text-right nowrap">
                                            {keyFigures['Garantienieveau']}%
                                        </td>
                                    </tr>
                                }
                                { portfolioType == 'perspektive' &&            
                                    <tr>
                                        <td>
                                            <strong>{gettext("kdGarantieProzent")}</strong> ({gettext("kdGarantieProzent", "de")})
                                        </td>
                                        <td className="text-right nowrap">
                                            90%
                                        </td>
                                    </tr>
                                }
                                <ContractLine name="totalPayments" value={parameters.payment} currencyExchange={this.props.currencyExchange} />
                            </tbody>
                        </table>

                    </div>
                </div>

                <div className="row justify-content-center xs-pt-50 offer">
                    <div className="col-12">

                        <h3>Lykiltölur</h3>
                        { portfolioType == 'perspektive' ? 
                        <table className="table table-hover table-sm table-offer table-responsive-sm">
                            <tbody>
                                <ContractLine name="Garantiekapital_perspektive" value={keyFigures["Garantiekapital"]} currencyExchange={this.props.currencyExchange} />
                                <ContractLine name="Gesamtkapital" value={keyFigures["Gesamtkapital"]} currencyExchange={this.props.currencyExchange} />
                                <ContractLine name="GesamtkapitalPlusProz" value={keyFigures["GesamtkapitalPlusProz"]} currencyExchange={this.props.currencyExchange} />
                                
                                {!isOneTimePayment &&
                                    <>
                                        <tr><td colSpan={2}>eða</td></tr>
                                        
                                        <ContractLine name="garantierte Mindestrente inklusive Zulagen" value={keyFigures["garantierte Mindestrente inklusive Zulagen"]} currencyExchange={this.props.currencyExchange} />
                                        <ContractLine name="GesamteRente" value={keyFigures["GesamteRente"]} currencyExchange={this.props.currencyExchange} />
                                        <ContractLine name="GesamtrentePlusProz" value={keyFigures["GesamtrentePlusProz"]} currencyExchange={this.props.currencyExchange} />
                                    </>
                                }
                                
                                { !isOneTimePayment ?
                                    <>
                                        <tr><td colSpan={2}>Iðgjald (Beitrag)</td></tr>
                                        <ContractLine name="TotalHauptprodukt" value={keyFigures["Hauptprodukt"]} currencyExchange={this.props.currencyExchange} eurDecimals={2}/>
                                    </>
                                    :
                                    <>
                                        <ContractLine name="ren.onetime" value={keyFigures["Hauptprodukt"]} currencyExchange={this.props.currencyExchange} />
                                    </>
                                }
                            </tbody>
                        </table> 
                        : 
                        
                        <table className="table table-hover table-sm table-offer table-responsive-sm">
                                <tbody>
                                    <ContractLine name="Garantiekapital_kd" value={keyFigures["Garantiekapital"]} currencyExchange={this.props.currencyExchange} />
                                    <ContractLine name="Gesamtkapital_kd" value={keyFigures["Gesamtkapital"]} currencyExchange={this.props.currencyExchange} />
                                    
                                    { !isOneTimePayment &&
                                        <>
                                        <tr><td colSpan={2}>eða</td></tr>
                                        
                                        <ContractLine name="garantierte Mindestrente inklusive Zulagen" value={keyFigures["GarantierteRente"]} currencyExchange={this.props.currencyExchange} />
                                        <ContractLine name="GesamteRente_kd" value={keyFigures["GesamteRente"]} currencyExchange={this.props.currencyExchange} />
                                    </>
                                    }  
                                    <tr>
                                        <td colSpan="2">
                                            <table className="table table-hover table-offer table-responsive-md inner-table">
                                                <thead>
                                                    <tr>
                                                        <th className="text-right">Ávöxtun</th>
                                                        <th className="text-right">Áætlaður mánaðarlegur lífeyrir</th>
                                                        <th className="text-right">Áætluð inneign í samningslok</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    
                                                {[...Array(6)].map((x, i) => {
                                                    let ind = i + 1 
                                                    return (
                                                        <tr key={`kd-projection-${ind}`}>
                                                            <td className="text-right">{keyFigures["HochrechnungsProzentsatz" + ind]}%</td>
                                                            <td className="text-right">{`${formatMoney(keyFigures["GesamteRente" + ind] * this.props.currencyExchange)} ISK`}</td>
                                                            <td className="text-right">{`${formatMoney(keyFigures["Gesamtkapital" + ind] * this.props.currencyExchange)} ISK`}</td>
                                                        </tr>
                                                    )
                                                }
                                                )}
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr><td colSpan={2}>{gettext('beitrag')} ({gettext('beitrag', 'de')})</td></tr>
                                    { !isOneTimePayment ?
                                        <>
                                        <ContractLine name="RSKU2" value={keyFigures["Hauptprodukt"]} currencyExchange={this.props.currencyExchange} eurDecimals={2} />
                                        </>
                                        :
                                        <ContractLine name="ren.onetime" value={keyFigures["Hauptprodukt"]} currencyExchange={this.props.currencyExchange} />
                                    }
                                    
                                </tbody>
                            </table>
                        }
                    </div>
                </div>


                <div className="row justify-content-center xs-pt-50 offer">
                    <div className="col-12">
                        <h3>{gettext("lifetimeHeading")} <span>({gettext("lifetimeHeading", "de")})</span></h3>
                    </div>
                </div>

                <div className="row justify-content-center xs-pt-50 offer">
                    <div className="col-12">
                        <Bar data={lifetimeData} options={options} />
                    </div>
                </div>
                <div className="row justify-content-center xs-pt-50 offer">
                    <div className="col-12">
                        <OfferTable timeseries={offer.tableTimeSeries} columns={lifetimeColumns} currencyExchange={this.props.currencyExchange} />
                    </div>
                </div>

                { !isOneTimePayment &&
                    <>
                        <div className="row justify-content-center xs-pt-50 offer">
                            <div className="col-12">
                                <h3>{gettext("postLifetimeHeading")} <span>({gettext("postLifetimeHeading", "de")})</span></h3>
                            </div>
                        </div>


                        <div className="row justify-content-center xs-pt-50 offer">
                            <div className="col-12">
                                <Bar data={postData} options={options} />
                            </div>
                        </div>
                        <div className="row justify-content-center xs-pt-50 offer">
                            <div className="col-12">
                                <OfferTable timeseries={offer.tableTimeSeries} columns={postColumns} currencyExchange={this.props.currencyExchange} />
                            </div>
                        </div>
                    </>
                }
            </>)
        }
    }
}

export default OfferVidt